import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { SelectBillingAddress, ShoppingCartBillingState } from '@platform-frontend/checkout';
import { BillingAddress, DeleteBillingAddress, MarketplaceBillingInformationState } from '@platform-frontend/marketplace';
import { tapNextOrError } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { BillingIdWithCallback } from '../../commercial-common/billing-id-with-callback';
import { NullableIdWithCallback } from '../../commercial-common/nullable-id-with-callback';

@UntilDestroy()
@Component({
  selector: 'yat-billing-address-selection',
  templateUrl: './billing-address-selection.component.html',
  styleUrls: ['./billing-address-selection.component.scss']
})
export class BillingAddressSelectionComponent {
  constructor(private store: Store) {}

  @Select(MarketplaceBillingInformationState.billingAddresses)
  billingAddresses$: Observable<BillingAddress[]>;

  @Select(ShoppingCartBillingState.selectedBillingAddress)
  selectedBillingAddress$: Observable<BillingAddress | null>;

  saveSelectedBillingAddress({ id, completeCallback }: NullableIdWithCallback): void {
    this.store
      .dispatch(new SelectBillingAddress(id))
      .pipe(
        tapNextOrError(() => completeCallback()),
        untilDestroyed(this)
      )
      .subscribe();
  }

  deleteBillingAddress({ id, completeCallback }: BillingIdWithCallback): void {
    this.store
      .dispatch(new DeleteBillingAddress(id))
      .pipe(
        tapNextOrError(() => completeCallback()),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
